import { Flex } from "styled-system/jsx";
import { ControlledInput } from "shared/components";
import { useTranslation } from "react-i18next";

export const SocialLinks = () => {
  const { t } = useTranslation();

  return (
    <Flex flexDir={"column"} gap={"200"}>
      <ControlledInput
        name={"facebook"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.FACEBOOK")}
      />
      <ControlledInput
        name={"instagram"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.INSTAGRAM")}
      />
      <ControlledInput
        name={"x"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.X")}
      />
      <ControlledInput
        name={"youtube"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.YOUTUBE")}
      />
      <ControlledInput
        name={"pinterest"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.PINTEREST")}
      />
      <ControlledInput
        name={"googleMyBusiness"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.GOOGLE_MY_BUSINESS")}
      />
      <ControlledInput
        name={"tiktok"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.TIKTOK")}
      />
      <ControlledInput
        name={"tripAdvisor"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.TRIP_ADVISOR")}
      />
      <ControlledInput
        name={"bookNow"}
        label={t("directory:OPERATOR.PROFILE.SOCIAL_LINKS.CUSTOM_BOOKING_LINK")}
      />
    </Flex>
  );
};
